import IconTile from '@Guidelines/Component/IconTile';
import resolveSubjectTypeColor from '@Guidelines/Component/SubjectTypeTile/Helpers/resolveSubjectTypeColor';
import resolveSubjectTypeIcon from '@Guidelines/Component/SubjectTypeTile/Helpers/resolveSubjectTypeIcon';
import type * as React from 'react';

type Props = { icon: string; color: string };

/** Icon tile of a subject type, from the `value` of its icon and color. */
const SubjectTypeTile: React.FC<Props> = ({ icon, color }) => {
	return <IconTile icon={resolveSubjectTypeIcon(icon)} color={resolveSubjectTypeColor(color)} />;
};

export default SubjectTypeTile;
